<template>
    <v-dialog persistent
              @keydown.esc="_cancel"
              v-model="openDialog"
              :retain-focus="false"
              width="550" style=" min-height: 350px">
        <v-card  >
            <v-card-title class="primary" >
                <h3 class="white--text">Επιβεβαίωση Ενέργειας</h3>
                <v-spacer></v-spacer>
                <v-icon @click="_cancel" color="white">close</v-icon>
            </v-card-title>

            <v-card-text style="background-color: #eaeaea" class="justify-center  pt-6">
                <v-row>
                    <v-col>
                        <h4 class="black--text">{{message}}</h4>
                    </v-col>
                </v-row>
            </v-card-text>


            <v-card-actions style="background-color: #eaeaea" class="justify-center pb-6 pt-2">
                <v-btn @click="_cancel" style="text-transform: none !important;" rounded outlined color="indianRed">
                    Άκυρο
                    <v-icon size="25" color="indianRed"  right dark> mdi-close-circle </v-icon>
                </v-btn>

                <v-btn  @click="_confirm" style="text-transform: none !important;" rounded outlined color="primary">
                    Επιβεβαίωση
                    <v-icon size="25" color="primary"  right dark> mdi-checkbox-marked-circle </v-icon>
                </v-btn>
            </v-card-actions>

        </v-card>
    </v-dialog>
</template>

<script>
	export default {
		name: 'CustomWindowConfirm',
		data: () => ({
            openDialog:false,
			title: undefined,
			message: undefined, // Main text content

			resolvePromise: undefined,
			rejectPromise: undefined,
		}),

		methods: {
			show(opts = {}) {
				this.message = opts.message;

                // Once we set our config, we tell the popup modal to open
				this.openDialog = true;
                // Return promise so the caller can get results
				return new Promise((resolve, reject) => {
					this.resolvePromise = resolve;
					this.rejectPromise = reject
				})
			},

			_confirm() {
				this.openDialog = false;
				this.resolvePromise(true)
			},

			_cancel() {
				this.openDialog = false;
				this.resolvePromise(false)
// Or you can throw an error
// this.rejectPromise(new Error('User canceled the dialogue'))
			},
		},
	}
</script>


<style scoped>
    .btns {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    .ok-btn {
        color: red;
        text-decoration: underline;
        line-height: 2.5rem;
        cursor: pointer;
    }

    .cancel-btn {
        padding: 0.5em 1em;
        background-color: #d5eae7;
        color: #35907f;
        border: 2px solid #0ec5a4;
        border-radius: 5px;
        font-weight: bold;
        font-size: 16px;
        text-transform: uppercase;
        cursor: pointer;
    }
</style>
